import type { ReactNode } from 'react'

import Meldung from './Meldung'

interface Eigenschaften {
  fehler?: string | null
  /** meist ein Satz; darf Links tragen („2 wartende Läufe neu bewertet: Lauf 41, Lauf 42“) */
  erfolg?: ReactNode
  titel?: string
}

/** Fehler und Bestätigung einer Seite - das Paar, das nach jeder Aktion über dem Inhalt steht. */
export default function Meldungen({ fehler, erfolg, titel = 'Fehlgeschlagen' }: Eigenschaften) {
  return (
    <>
      {fehler && (
        <Meldung art="fehler" titel={titel}>
          {fehler}
        </Meldung>
      )}
      {erfolg && <Meldung art="gut">{erfolg}</Meldung>}
    </>
  )
}
